
import Vue, { defineComponent, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router/composables';
import { getUserTOSConfig } from '@/common/services/account/termsOfServices';
import { getDefaultPath } from '@/common/services/account/userNavigation';
import TermsReview from '@/features/user/components/TermsReview.vue';

export default defineComponent({
  metaInfo() {
    return {
      title: Vue.t('TermsAcceptance.title')
    };
  },
  components: {
    TermsReview
  },
  setup() {
    const router = useRouter();
    const tosConfig = getUserTOSConfig();

    onBeforeMount(() => {
      // Do not show TOS page if no config is setup or TOS check is disabled
      if (!tosConfig || !tosConfig.enabled) {
        const defaultPath = getDefaultPath();
        router.push(defaultPath);
      }
    });

    function onTermsAccepted() {
      const defaultPath = getDefaultPath();
      router.push(defaultPath);
    }

    return {
      tosConfig,
      onTermsAccepted
    };
  }
});
